import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Helpers } from '@core/helpers/helpers';

@Injectable()
export class HashInterceptor implements HttpInterceptor {


  constructor(
    private helper: Helpers
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    var newRequest = request.clone({
      setHeaders: { 'key': this.helper.generateApplicationHash() }
    })
    return next.handle(newRequest);
  }
/* 
  generateDownloadToken(url: string): string {
    const date = new Date();
    const create = date.setMinutes(date.getMinutes());
    const expire = date.setMinutes(date.getMinutes() + 120);

    var token = {
      data: '',
      createDate: new Date(create),
      expireDate: new Date(expire)
    }
    const password = this.config.hashKey;
    var iv = CryptoJS.enc.Utf8.parse(password);

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(token)), password,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }
 */
}
